import { useCallback, useEffect } from 'react';

// Hook to work around the mobile browser viewport height issue
// Relevant for
//   - @mixin max-height-viewport
//   - index.scss

export default function useSetViewportHeight() {
    const updateVhCssVar = useCallback(() => {
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        let vh = viewportHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, []);

    useEffect(() => {
        updateVhCssVar();

        window.addEventListener('resize', updateVhCssVar);
        window.visualViewport?.addEventListener('resize', updateVhCssVar);
        window.addEventListener('orientationchange', updateVhCssVar);

        return () => {
            window.removeEventListener('resize', updateVhCssVar);
            window.visualViewport?.removeEventListener('resize', updateVhCssVar);
            window.removeEventListener('orientationchange', updateVhCssVar);
        };
    }, [updateVhCssVar]);
}